/**
 * Visible square border around the game world.
 */

import { Line } from '@react-three/drei';

interface MapBorderProps {
  readonly halfSize: number;
}

const BORDER_COLOR = '#cc5544';

export function MapBorder({ halfSize }: MapBorderProps) {
  const h = halfSize;
  const points: [number, number, number][] = [
    [-h, 0, -h],
    [h, 0, -h],
    [h, 0, h],
    [-h, 0, h],
    [-h, 0, -h],
  ];

  return (
    <Line
      points={points}
      color={BORDER_COLOR}
      lineWidth={2}
      transparent
      opacity={0.85}
    />
  );
}
